module.exports = __webpack_public_path__ + "img/Cubew.cf26f097.png";